/*eslint-disable*/
import * as _ from "lodash";

const GAMES_THAT_CAN_BE_COMPARED = [
    'AdditionAndSubtraction',
    'AdditionAndSubtractionWithTime',
    'MultiplicationAndDivision',
    'Equation',
    'Anzan'
];

const STRING_DIFFICULTIES = [
    'Пятизначные цифры',
    'Четырехзначные цифры',
    'Трехзначные цифры',
    'Двузначные цифры',
    'Однозначные цифры'
];

export default {
    data () {
        return {
            gamesForComparison: []
        }
    },
    methods: {
        getGamesAfterComparison () {
            let gamesAfterComparison = [];
            _.forIn(this.groupedGamesFromAllCourses, (arrayOfGames, slug) => {
                if (arrayOfGames.length > 1) {
                    if (GAMES_THAT_CAN_BE_COMPARED.includes(slug)) {
                        let compareResult = this['compare' + slug](arrayOfGames);
                        gamesAfterComparison = _.concat(gamesAfterComparison, compareResult);
                    } else {
                        gamesAfterComparison.push(_.head(arrayOfGames));
                    }
                } else if (arrayOfGames.length === 1) {
                    gamesAfterComparison = _.concat(gamesAfterComparison, arrayOfGames);
                }
            });
            this.gamesForComparison = [];
            return gamesAfterComparison;
        },
        compareAdditionAndSubtraction (arrayOfGames, withTime = false) {
            let result = this.getResultOfComparisonByStringDifficult(arrayOfGames);
            if (result.length > 1) {
                result = this.getResultOfComparisonBySimpleOptions(result);
                if (result.length > 1) {
                    result = this.getResultOfComparisonByBrothersOptions(result);
                    if (result.length > 1) {
                        result = this.getResultOfComparisonByFriendsOptions(result);
                        if (result.length > 1) {
                            result = this.getResultOfComparisonByBrothersAndFriendsOptions(result);
                            if (result.length > 1) {
                                result = this.getResultOfComparisonByJumpOverOptions(result);
                                if (result.length > 1) {
                                    if (withTime) {
                                        result = this.getResultOfComparisonExtraOptions(result);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return result.length ?
                result.length > 1 ? [_.head(result)] : result
                : [_.head(arrayOfGames)];
        },
        compareAdditionAndSubtractionWithTime (arrayOfGames) {
            return this.compareAdditionAndSubtraction(arrayOfGames, true);
        },
        compareMultiplicationAndDivision (arrayOfGames) {
            let result = this.getResultOfComparisonByMultAndDivDigitCapacities(arrayOfGames);
            if (result.length > 1) {
                result = this.getResultOfComparisonByAmountsOfAvailableNumbers(arrayOfGames);
            }
            return result.length ?
                result.length > 1 ? [_.head(result)] : result
                : [_.head(arrayOfGames)];
        },
        compareEquation (arrayOfGames) {
            let result = this.getResultOfComparisonByStringDifficult(arrayOfGames);
            return result.length ?
                result.length > 1 ? [_.head(result)] : result
                : [_.head(arrayOfGames)];
        },
        compareAnzan (arrayOfGames) {
            let result = this.getResultOfComparisonByNumDifficult(arrayOfGames);
            if (result.length > 1) {
                this.getResultOfComparisonExtraOptions(arrayOfGames);
            }
            return result.length ?
                result.length > 1 ? [_.head(result)] : result
                : [_.head(arrayOfGames)];
        },
        getResultOfComparisonByNumDifficult (arrayOfGames) {
            let groupedByDifficult = _.groupBy(arrayOfGames, 'parameters.default.difficult');
            let maxDiff = Math.max(..._.keys(groupedByDifficult));
            return groupedByDifficult[maxDiff] || arrayOfGames;
        },
        getResultOfComparisonByStringDifficult (arrayOfGames) {
            let groupedByDifficult = _.groupBy(arrayOfGames, 'parameters.default.difficult');
            for (let difficult of STRING_DIFFICULTIES) {
                if (groupedByDifficult[difficult]) {
                    return groupedByDifficult[difficult];
                }
            }
            return arrayOfGames;
        },
        getResultOfComparisonBySimpleOptions (arrayOfGames) {
            let groupedBySimple = _.groupBy(arrayOfGames, 'parameters.default.simple.length');
            let maxLength = Math.max(..._.keys(groupedBySimple));
            return groupedBySimple[maxLength] || arrayOfGames;
        },
        getResultOfComparisonByBrothersOptions (arrayOfGames) {
            let groupedByBrothers = _.groupBy(arrayOfGames, 'parameters.default.brothers.length');
            let maxLength = Math.max(..._.keys(groupedByBrothers));
            return groupedByBrothers[maxLength] || arrayOfGames;
        },
        getResultOfComparisonByFriendsOptions (arrayOfGames) {
            let groupedByFriends = _.groupBy(arrayOfGames, 'parameters.default.friends.length');
            let maxLength = Math.max(..._.keys(groupedByFriends));
            return groupedByFriends[maxLength] || arrayOfGames;
        },
        getResultOfComparisonByBrothersAndFriendsOptions (arrayOfGames) {
            let groupedByBrothersAndFriends = _.groupBy(arrayOfGames, 'parameters.default.brothersAndFriends.length');
            let maxLength = Math.max(..._.keys(groupedByBrothersAndFriends));
            return groupedByBrothersAndFriends[maxLength] || arrayOfGames;
        },
        getResultOfComparisonByJumpOverOptions (arrayOfGames) {
            let groupedByJumpOver = _.groupBy(arrayOfGames, 'parameters.default.jumpOver.length');
            let maxLength = Math.max(..._.keys(groupedByJumpOver));
            return groupedByJumpOver[maxLength] || arrayOfGames;
        },
        getResultOfComparisonExtraOptions (arrayOfGames) {
            let result = this.getResultOfComparisonByVoiceOver(arrayOfGames);
            return result.length ?
                result.length > 1 ? [_.head(result)] : result
                : [_.head(arrayOfGames)];
        },
        getResultOfComparisonByVoiceOver (arrayOfGames) {
            let groupedByVoiceOver = _.groupBy(arrayOfGames, 'parameters.default.extraOptions.voiceOver');
            return groupedByVoiceOver['true'] ? groupedByVoiceOver['true'] : arrayOfGames;
        },
        getResultOfComparisonByMultAndDivDigitCapacities (arrayOfGames) {
            let groupedBySumOfCounts = _.groupBy(arrayOfGames, game => {
                return game.parameters.default.digitCapacity.left.length +
                    game.parameters.default.digitCapacity.right.length;
                }
            );
            let maxSumOfDigitCapacities = Math.max(..._.keys(groupedBySumOfCounts));
            return groupedBySumOfCounts[maxSumOfDigitCapacities] || arrayOfGames;
        },
        getResultOfComparisonByAmountsOfAvailableNumbers (arrayOfGames) {
            let groupedByAmountOfAvailableNumbers = _.groupBy(arrayOfGames, 'game.parameters.default.numbers.length');
            let maxSumOfDigitCapacities = Math.max(..._.keys(groupedByAmountOfAvailableNumbers));
            return groupedByAmountOfAvailableNumbers[maxSumOfDigitCapacities] || arrayOfGames;
        }
    },
    computed: {
        groupedGamesFromAllCourses () {
            return _.groupBy(this.gamesForComparison, 'slug');
        }
    }
}